





































































































































import { Component, Watch } from 'vue-property-decorator';
import BusinessPlanReportConfirmation from '@/modals/BusinessPlanReportConfirmation.vue';
import {
  AdmiralException,
  FivGoalGroupType,
  IFivGoal,
  IFivGoalGroup,
  IFivReport,
  IUploadBusinessPlanReport,
  PRO3_VALID_GOALS,
} from 'admiral-core';
import { FileTextIcon, PlusIcon, UploadIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import dayjs from 'dayjs';
import { BusinessPlanApi } from '@/services/BusinessPlanApi';
import draggable from 'vuedraggable';
import { FivApi } from '@/services/FivApi';
import { DEFAULT_BUSINESS_PLAN_ORDER } from '@/store/PreferencesModule';
import GoalSelect from '@/components/common/selects/GoalSelect.vue';
import AgencyGoalSelectionBoxes from '@/views/pages/fivgoals/AgencyGoalSelectionBoxes.vue';

import FivGoalChart from '@/views/pages/fivgoals/FivGoalChart.vue';
import FivRangeGoalChart from '@/views/pages/fivgoals/FivRangeGoalChart.vue';
import ReportListOverview from '@/views/pages/fivgoals/ReportListOverview.vue';

@Component({
  components: {
    FivRangeGoalChart,
    AgencyGoalSelectionBoxes,
    GoalSelect,
    BusinessPlanReportConfirmation,
    FivGoalChart,
    UploadIcon,
    PlusIcon,
    ReportListOverview,
    FileTextIcon,
    draggable,
  },
})
export default class BusinessPlan extends mixins(BaseMixin) {
  reportFiles = '';

  report: IFivReport | null = null;
  reports: IFivReport[] = [];
  goalGroup: IFivGoalGroup | null = null;
  uploadedBusinessPlanReport: IUploadBusinessPlanReport | null = null;
  error = '';

  dragOptions = {
    animation: 200,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost',
  };

  drag = false;
  isLoading = false;

  allBusinessGoals: IFivGoal[] = [];

  @Watch('fivGoalsFilter')
  async watchFivGoalsFilter() {
    await this.loadAll();
  }

  async fetchGoalGroup() {
    try {
      const response = await FivApi.getGoalGroup({
        agency: this.agency,
        groupType: FivGoalGroupType.BusinessPlan,
        year: this.fivGoalsFilter.year,
      });
      this.goalGroup = response.data;
    } catch (e) {
      //TODO
      console.log(e);
    }
  }

  async fetchReports() {
    try {
      const response = await BusinessPlanApi.getLatestBusinessPlanReport({
        agency: this.agency,
        year: this.fivGoalsFilter.year,
      });
      this.reports = response.data;
      if (this.reports.length > 0) {
        this.report = this.reports[0];
      } else {
        this.report = null;
      }
    } catch (e) {
      //TODO
      console.log(e);
    }
  }

  async fetchGoals() {
    try {
      if (this.goalGroup) {
        const allGoalsResponse = await FivApi.getGoalGroupGoals({
          group: this.goalGroup,
        });

        this.allBusinessGoals = allGoalsResponse.data;
      }
    } catch (e) {
      console.log(e);
    }
  }

  resetGoalOrder() {
    if (this.goalOrder.length > 0) {
      const firstElement = this.goalOrder[0];

      if (firstElement) {
        const isUUID = firstElement.match(
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
        );

        if (isUUID) {
          this.$store.commit('PreferencesModule/updateOrder', DEFAULT_BUSINESS_PLAN_ORDER);
        }
      }
    }
  }

  async mounted() {
    await this.loadAll();
  }

  async loadAll() {
    this.$Progress.start();
    this.resetGoalOrder();
    this.isLoading = true;

    await this.fetchGoalGroup();
    await this.fetchReports();
    await this.fetchGoals();

    this.isLoading = false;

    this.$Progress.finish();
  }

  get isPro3Agency() {
    return this.allBusinessGoals.some((goal: IFivGoal) => {
      return (PRO3_VALID_GOALS as string[]).includes(goal.name);
    });
  }

  get hasAPGoals() {
    return this.allBusinessGoals.some((goal: IFivGoal) => {
      return (PRO3_VALID_GOALS as string[]).includes(goal.name);
    });
  }

  get hasSachZUWBFPGoals() {
    return this.allBusinessGoals.some((goal: IFivGoal) => {
      return goal.name.startsWith('Sach BZUWB FP');
    });
  }

  isPro3Goal(goal: IFivGoal) {
    return goal.name.startsWith('Gesamtbewertung AP') || goal.name.startsWith('Sach BZUWB FP');
  }

  getPro3Goals(goal: IFivGoal): IFivGoal[] {
    if (goal.name.startsWith('Gesamtbewertung AP')) {
      return this.allBusinessGoals.filter((goal: IFivGoal) =>
        goal.name.startsWith('Gesamtbewertung AP'),
      );
    } else if (goal.name.startsWith('Sach BZUWB FP')) {
      return this.allBusinessGoals.filter((goal: IFivGoal) =>
        goal.name.startsWith('Sach BZUWB FP'),
      );
    }
    return [];
  }

  get pro3Gesamt(): IFivGoal[] {
    return this.allBusinessGoals.filter((goal: IFivGoal) =>
      goal.name.startsWith('Gesamtbewertung AP'),
    );
  }
  get pro3Sach() {
    return this.allBusinessGoals.filter((goal: IFivGoal) => goal.name.startsWith('Sach BZUWB FP'));
  }

  get businessPlanReportGoals() {
    let goals = this.allBusinessGoals || [];

    // remove pro3 goals
    goals = goals.filter(
      (goal: IFivGoal) =>
        !goal.name.startsWith('Gesamtbewertung AP') && !goal.name.startsWith('Sach BZUWB FP'),
    );

    const checkSort = 'Gesamtbewertung';
    return goals
      .sort((a, b) => {
        return this.goalOrder.indexOf(a.name) - this.goalOrder.indexOf(b.name);
      })
      .sort(function (x, y) {
        return x.name == checkSort ? -1 : y.name == checkSort ? 1 : 0;
      });
  }

  set businessPlanReportGoals(goals: IFivGoal[]) {
    this.$store.commit('PreferencesModule/updateOrder', goals);
  }

  get goalOrder(): string[] {
    return this.$store.getters['PreferencesModule/getBusinessPlanGoalsOrder'] as string[];
  }

  formatDate(date: Date) {
    return dayjs(date).format('DD.MM.YYYY');
  }

  formatIntervalDateItem(date: Date) {
    return dayjs(date).format('MM/YYYY');
  }

  reload() {
    window.location.reload();
  }

  async handleFileUpload() {
    // eslint-disable-next-line
    this.reportFiles = (this.$refs.file as any).files;
    const formData = new FormData();

    for (let i = 0; i < this.reportFiles.length; i++) {
      formData.append('file' + i, this.reportFiles[i]);
    }

    try {
      const responseUpload = await BusinessPlanApi.uploadBusinessPlanReport(
        this.goalGroup!.id,
        formData,
      );

      this.uploadedBusinessPlanReport = {
        status: 'new',
        missingReports: [],
        parts: responseUpload.data,
      };

      const responseValidate = await BusinessPlanApi.validateUploadedBusinessPlanReport(
        this.uploadedBusinessPlanReport,
      );

      this.uploadedBusinessPlanReport = responseValidate.data;
    } catch (e: any) {
      const exception = e.response?.data as AdmiralException;
      if (exception.errors) {
        const errors = exception.errors;
        this.error = 'Beim Hochladen des Geschäftplans ist etwas schiefgelaufen.';

        if (errors['TooManyFiles']) {
          this.error = 'Es können maximal 2 Dateien gleichzeitig hochgeladen werden.';
        } else if (errors['CorruptedExcel']) {
          this.error =
            'FIV-exportierte Dateien dürfen nicht beabreitet werden. Bitte den Geschäftsplan unbearbeitet hochladen.  ';
        } else if (errors['InvalidBusinessPlanReport']) {
          this.error =
            'Ungültiger Geschäftsplan: Folgende Geschäftspläne sind zulässig: ' +
            errors['InvalidBusinessPlanReport'];
        }
      }

      this.uploadedBusinessPlanReport = {
        status: 'error',
        error: this.error,
      };
      // eslint-disable-next-line
      (this.$refs['business-plan-report-confirmation'] as any).$refs[
        'business-plan-report-confirmation-modal'
      ].show();
      (this.$refs.file as HTMLFormElement).value = '';

      this.$toastr.e(
        'Beim Hochladen des Geschäftsplans ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }

    // eslint-disable-next-line
    (this.$refs['business-plan-report-confirmation'] as any).$refs[
      'business-plan-report-confirmation-modal'
    ].show();
    (this.$refs.file as HTMLFormElement).value = '';
  }

  async updateBusinessPlan(uploadBusinessPlanReport: IUploadBusinessPlanReport) {
    this.uploadedBusinessPlanReport = uploadBusinessPlanReport;
  }

  openFileUpload() {
    (this.$refs.file as HTMLFormElement).click();
  }

  deleteReport(report: IFivReport) {
    this.reports = this.reports.filter((r) => r.id !== report.id);
    if (this.report?.id === report.id) {
      this.report = this.reports.length > 0 ? this.reports[0] : null;
    }
  }

  async selectReport(report: IFivReport) {
    this.report = this.reports.find((r) => r.id === report.id) || null;
    this.allBusinessGoals = [];
    await this.fetchGoals();
  }

  async reportUploadComplete(report: IFivReport) {
    this.isLoading = true;
    this.reports = [];
    this.allBusinessGoals = [];
    await this.fetchReports();
    await this.fetchGoals();
    this.uploadedBusinessPlanReport = null;

    this.isLoading = false;
  }
  reportUploadCancel() {
    this.uploadedBusinessPlanReport = null;
  }
  isLargeColumn(goal: IFivGoal) {
    return goal.name.startsWith('Gesamtbewertung') || goal.name.startsWith('Sach BZUWB FP');
  }
}
